import { Controller } from "@hotwired/stimulus";

import SlimSelect from "slim-select";

require("slim-select/dist/slimselect.min.css");

export default class extends Controller {
  static targets = [
    "template",
    "product",
    "quantity",
    "items"
  ];

  static values = {
    persisted: String
  };

  get productSelectController() {
    // https://github.com/hotwired/stimulus/issues/35
    return this.application.getControllerForElementAndIdentifier(
        this.element,
        "product-select"
    );
  }

  connect() {
    this.product = null;
  }

  addTableRow(event) {
    event.preventDefault();
    var product_id = this.productSelectController.productTarget.value;
    if (product_id !== "undefined") {
      this.getProduct(product_id);
    }
  }

  addAssociation() {
    var content = this.templateTarget.innerHTML.replace(
      /TEMPLATE_RECORD/g,
      // new Date().valueOf()
      this.itemsTarget.querySelectorAll(".nested-fields").length
    );
    if (this.persistedValue == "true") {
      this.templateTarget.insertAdjacentHTML("beforebegin", content);
    } else {
      this.templateTarget.insertAdjacentHTML("afterend", content);
    }
    this.addFieldValues();
  }

  addFieldValues() {
    var items = this.itemsTarget.querySelectorAll(".nested-fields");
    console.log(this.persistedValue == "true")
    if (this.persistedValue == "true") {
      var item = items[items.length - 1];
    } else {
      var item = items[0];
    }

    item.querySelector("input[name*='product_id']").value = this.product.id;
    item.querySelector(
        "input[name*='product_name']"
    ).value = `${this.product.name} (${this.product.code})`;

    item.querySelector("input[name*='quantity']").value = 1;

    if (this.product.variants.length > 0) {
      this.addVariants(item);
    }
  }

  addVariants(item) {
    var selectVariant = item.querySelector("select[name*=variants]");
    selectVariant.innerHTML = "";

    var filtered_variants = this.product.variants.filter((variant, i) => {
      return variant.warehouse_id == this.warehouseTarget.value;
    });

    filtered_variants.forEach((variant, i) => {
      selectVariant.innerHTML +=
          '<option value ="' + variant.id + '">' + variant.name + "</option>";
    });

    // add variantvalues with first variant
    var variant = filtered_variants[0];
    if (variant) {
      this.addVariantValues(item, variant.id, "(" + variant.name + ")");
    }
  }

  addVariantValues(item, value, text) {
    item.querySelector("input[name*='product_variant_id']").value = value;
    var value = item.querySelector("input[name*='product_name']").value;

    if (/\(.*\)/.test(value)) {
      item.querySelector("input[name*='product_name']").value = value.replace(
          /\(.*\)/,
          text
      );
    } else {
      item.querySelector("input[name*='product_name']").value =
          value + " " + text;
    }
  }

  remove_association(event) {
    event.preventDefault()
    const item = event.target.closest(".nested-fields")
    if (item) {
      const destroyField = item.querySelector("input[name*='_destroy']")
      if (destroyField) {
        destroyField.value = "1"
        item.style.display = "none"
      }
    }
  }

  getProduct(id) {
    // TODO: persist and use result data from searchProducts
    Rails.ajax({
      type: "GET",
      url: `/products/${id}.json`,
      success:  (data, status, xhr) => {
        this.product = data;
        this.addAssociation();
      },
    });
  }
}
